import React from 'react';
import './BrRule.scss';

const BrRule = () => <div className="br-rule"></div>;

export default BrRule;
